import { allCombos } from './combos';

/**
 * Find all (direct & indirect) parents of the newly selected area
 * @param {string} areaId
 * @param {Set} visited
 * @returns {array}
 */
// Helper function to find all parents that contain a specific area (directly or indirectly)
// Some notes:
// - This function is recursive
// - It starts with an empty Set (Array with unique values)
// - It prevents infinite recursion by keeping track of visited areas
// - Once it finds the direct parents, it treats each parent as a new area and finds its parents
// - It returns all unique parents ids (direct and indirect)
const findAllParentsIds = (areaId, visited = new Set()) => {
  // Prevent infinite recursion
  if (visited.has(areaId)) {
    return [];
  }
  visited.add(areaId);

  // Find all direct parents
  const directParents = allCombos
    .filter((combo) => combo.childrenIds.includes(areaId)) // This finds the parents objects
    .map((combo) => combo.parentId); // This extracts the parent ids

  // Find all indirect parents (parents of parents)
  const indirectParents = directParents.flatMap((parentId) =>
    // Treat each parent as a new area and find its parents
    findAllParentsIds(parentId, new Set(visited))
  );

  // Return all unique parents (direct and indirect)
  return [...new Set([...directParents, ...indirectParents])];
};

// -------------------------------------------------------- //

/**
 * Checks if a body area is already included in any of the selected larger areas
 * @param {Object} area - The newly selected area object with an id property
 * @param {Object[]} selectedAreas - Array of already selected area objects with id properties
 * @returns {Object|null} - The larger area object that includes the selected area, or null if none found
 */
export const checkForLarger = (area, selectedAreas) => {
  // Handle null or undefined inputs
  if (!area || !area.id || !Array.isArray(selectedAreas)) {
    return null;
  }

  // 1. Find all (direct & indirect) parents of the newly selected area
  const parentsIds = findAllParentsIds(area.id); // Returns an array of parent ids

  // 2. Find the first selected area that contains our new area
  const largerArea = selectedAreas.find(
    (selected) => selected && parentsIds.includes(selected.id)
  );

  return largerArea || null;
};

// -------------------------------------------------------- //

// ------- Original code below ------- Deprecated ------- //
// import { forbiddenCombo, combinable, allChildrenIds } from './combos';
// /**
//  * @function checkForLarger - checks if the selected areas has a related largeArea area
//  * @param {Object} smallArea - a to be added small area
//  * @param {Array} selectedAreas - array of selected areas
//  * @returns object or undefined
//  */
// export const checkForLarger = (smallArea, selectedAreas) => {
//   // Check if selectedAreas has the corresponding largeArea area
//   if (allChildrenIds.some((id) => id === smallArea.id)) {
//     // Find the largeArea area of the (to be added) small area
//     const findLarger = (combo) =>
//       combo.find((elem) =>
//         elem.childrenIds.some((item) => item === smallArea.id)
//       );
//     // IMPORTANT: Start with forbiddenCombo first, then check combinable
//     let largeArea = findLarger(forbiddenCombo) || findLarger(combinable);

//     let foundLarger = selectedAreas.find(
//       (item) => item.id === largeArea.parentId
//     );
//     console.log('largeArea above:', largeArea);
//     if (foundLarger) return foundLarger;
//     else {
//       // Keep repeating the same process until the largest area is found
//       console.log('largeArea down:', largeArea);
//       largeArea.id = largeArea.parentId;
//       return checkForLarger(largeArea, selectedAreas);
//     }
//   } else return undefined; // When no larger area is found
// };
